module.exports = __webpack_public_path__ + "media/customizations/regencyatauburnstation/back-2833ce9d9fee2ec07e530fe1b8d2bede.jpg";